import { faChevronLeft, faPlay, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from '@headlessui/react'
import { useState } from 'react'
import ReactPlayer from 'react-player'
import { placementData } from '../../common/constants'



const PlacementModal = ({ isOpen, setIsOpen }) => {

    const [ showPlayer, setShowPlayer ] = useState(false)
    const [ videoUrl, setVideoUrl ] = useState('')

    const handleVideo = (index) => {
        setShowPlayer(true)
        setVideoUrl(placementData[index]?.video_link)
    }

    const closeModal = () => {
        setShowPlayer(false)
        setIsOpen(false)
    }

    return (
        <div>
            <Dialog 
                open={isOpen}
                onClose={closeModal}
                className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
            >
                <Dialog.Overlay className="fixed inset-0 bg-black/60 backdrop-blur-[10px]" />
                <div className="relative z-10 w-full max-w-2xl">
                    <Dialog.Title/>
                    <Dialog.Description/>
                    {!showPlayer ? <div className='bg-[#2D4F71] p-3 rounded-2xl max-h-[80vh] overflow-y-auto text-white'>
                    <h3 className='text-xl leading-6 font-medium pr-8'>Standout & Become 100% Job Ready</h3>
                    <div className='absolute right-3 top-3 cursor-pointer' onClick={() => setIsOpen(false)}>
                        <FontAwesomeIcon icon={faXmark} className='text-2xl'/>
                    </div>
                    <p className='text-sm leading-4 text-white/50 mt-1'>Join our 4 week placement support & interview training program. Get hired 3x faster!</p>
                    <div className='flex flex-col gap-2 mt-5 relative'>
                        {placementData?.map((item, index) => (
                            <div key={index} className='flex items-center gap-2'>
                                {index === 0 ? <div className='flex flex-col items-center text-xs font-bold z-50'>
                                    <div className='w-[21px] h-[21px] border-[1.5px] text-[15px] font-bold bg-[#14395F] flex items-center justify-center rounded-full'>
                                        1
                                    </div>
                                    <p>&</p>
                                    <div className='w-[21px] h-[21px] border-[1.5px] text-[15px] font-bold bg-[#14395F] flex items-center justify-center rounded-full'>
                                        2
                                    </div>
                                </div> : <div className='z-50'>
                                    <div className='w-[21px] h-[21px] border-[1.5px] text-[15px] font-bold bg-[#14395F] flex items-center justify-center rounded-full'>
                                        {index + 2}
                                    </div>
                                </div>}
                                <div className='bg-[#14395F] flex-1 flex items-center gap-2 p-2 rounded-xl'>
                                    <div className='relative w-[85px] h-full cursor-pointer' onClick={() => handleVideo(index)}>
                                        <img src={item.thumbnail} className='w-full h-auto' alt="" />
                                        <FontAwesomeIcon icon={faPlay} className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'/>
                                    </div>
                                    <div className='flex-1'>
                                        <h3 className='text-sm font-semibold text-white/50'>Week {index + 1}</h3>
                                        <p className='text-[11px] font-semibold'>{item.title}</p>
                                        <p className='text-[11px] font-semibold text-white/70 leading-3'>{item.subtitle}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className='w-2 absolute h-[73%] bg-[#6582A0] top-[18%] left-[7px]'/>
                    </div>
                </div> : <div className='bg-[#2D4F71] p-3 rounded-2xl text-white'>
                    <div className='flex justify-between items-center mb-3 px-2'>
                        <FontAwesomeIcon icon={faChevronLeft} className='text-2xl cursor-pointer' onClick={() => setShowPlayer(false)}/>
                        <FontAwesomeIcon icon={faXmark} className='text-3xl cursor-pointer' onClick={closeModal}/>
                    </div>
                    <ReactPlayer
                        url={videoUrl}
                        config={{
                        file: {
                            attributes: {
                            preload: 'auto',
                            },
                        },
                        youtube: {
                            playerVars: { modestbranding: 1, rel: 0 },
                        },
                        }}
                        width={"100%"}
                        height={
                        window.innerWidth > 768
                            ? window.innerWidth * (9 / 16) * (5 / 12)
                            : window.innerWidth * (9 / 16)
                        }
                        controls={true}
                        playing={true}
                    />
                </div>}
                </div>
            </Dialog>
        </div>
    )
}

export default PlacementModal